import { BaseEntity } from './base-entity';

export interface Workspace extends BaseEntity {
  commune?: string;
  name: string;
  shy: boolean;
  allowedYears: string[];
  typeGroups: Record<string, string[]>;
}

export type WorkspaceTypeKey =
  | 'indicatorCategory'
  | 'dataLayerType'
  | 'poiDataLayerType'
  | 'bookmarkCategory'
  | 'topic';

export interface WorkspaceType {
  label: string;
  icon: string;
  value: WorkspaceTypeKey;
  items?: Workspace[];
}

export type WorkspaceChildren = Record<WorkspaceTypeKey, string[]>;

export const workspaceTypeIconMap: Record<WorkspaceTypeKey, string> = {
  indicatorCategory: 'fas fa-folder',
  dataLayerType: 'fas fa-map',
  poiDataLayerType: 'fas fa-location-dot',
  bookmarkCategory: 'fas fa-layer-group',
  topic: 'fas fa-book-open',
};

export const asWorkspaceTypeKey = (type: any): WorkspaceTypeKey => {
  return type;
};
